import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api.js';

export default function Company() {
  const { t } = useTranslation();
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ['company'], queryFn: () => api('/api/company') });
  const [form, setForm] = useState(null);

  useEffect(() => { if (data?.company && !form) setForm(data.company); }, [data]);

  const save = useMutation({
    mutationFn: body => api('/api/company', { method: 'PUT', body }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['company'] }),
  });
  if (!form) return <div className="card">{t('common.loading')}</div>;
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const submit = e => {
    e.preventDefault();
    const payload = { ...form };
    delete payload.id; delete payload.updatedAt;
    save.mutate(payload);
  };
  return (
    <>
      <div className="page-header"><h1>{t('company.title')}</h1></div>
      <form className="card" onSubmit={submit}>
        <div className="row">
          <div className="field"><label>{t('common.name')}</label><input required value={form.name} onChange={e => set('name', e.target.value)} /></div>
          <div className="field"><label>{t('clients.legalName')}</label><input value={form.legalName || ''} onChange={e => set('legalName', e.target.value)} /></div>
        </div>
        <div className="row">
          <div className="field"><label>{t('clients.nuis')}</label><input value={form.nuis || ''} onChange={e => set('nuis', e.target.value)} /></div>
          <div className="field"><label>{t('clients.vatNumber')}</label><input value={form.vatNumber || ''} onChange={e => set('vatNumber', e.target.value)} /></div>
        </div>
        <div className="field"><label>{t('clients.address')}</label><input value={form.address || ''} onChange={e => set('address', e.target.value)} /></div>
        <div className="row">
          <div className="field"><label>{t('clients.city')}</label><input value={form.city || ''} onChange={e => set('city', e.target.value)} /></div>
          <div className="field"><label>{t('clients.country')}</label><input maxLength={2} value={form.country} onChange={e => set('country', e.target.value.toUpperCase())} /></div>
        </div>
        <div className="row">
          <div className="field"><label>{t('common.phone')}</label><input value={form.phone || ''} onChange={e => set('phone', e.target.value)} /></div>
          <div className="field"><label>{t('common.email')}</label><input type="email" value={form.email || ''} onChange={e => set('email', e.target.value)} /></div>
        </div>
        <div className="row">
          <div className="field"><label>Website</label><input value={form.website || ''} onChange={e => set('website', e.target.value)} /></div>
          <div className="field"><label>Logo URL</label><input value={form.logoUrl || ''} onChange={e => set('logoUrl', e.target.value)} /></div>
        </div>
        <h3 className="mt-16">{t('company.bank')}</h3>
        <div className="row">
          <div className="field"><label>{t('company.bankName')}</label><input value={form.bankName || ''} onChange={e => set('bankName', e.target.value)} /></div>
          <div className="field"><label>{t('company.iban')}</label><input value={form.bankIban || ''} onChange={e => set('bankIban', e.target.value)} /></div>
          <div className="field"><label>{t('company.swift')}</label><input value={form.bankSwift || ''} onChange={e => set('bankSwift', e.target.value)} /></div>
        </div>
        <div className="row">
          <div className="field"><label>{t('company.baseCurrency')}</label><input maxLength={3} value={form.baseCurrency} onChange={e => set('baseCurrency', e.target.value.toUpperCase())} /></div>
          <div className="field"><label>{t('common.language')}</label>
            <select value={form.defaultLang} onChange={e => set('defaultLang', e.target.value)}>
              <option value="en">EN</option><option value="sq">SQ</option>
            </select>
          </div>
        </div>
        <div className="row">
          <div className="field"><label><input type="checkbox" checked={form.preventOversell} onChange={e => set('preventOversell', e.target.checked)} /> {t('company.preventOversell')}</label></div>
          <div className="field"><label>{t('company.lowStockThreshold')}</label><input type="number" min={0} value={form.lowStockThreshold} onChange={e => set('lowStockThreshold', Number(e.target.value))} /></div>
        </div>
        <div className="modal-actions">
          <button type="submit" className="btn btn-primary" disabled={save.isPending}>{save.isPending ? <span className="spinner" /> : t('common.save')}</button>
        </div>
      </form>
    </>
  );
}
